<template>
  <div class="contact rfs18">
    <van-button plain :type="type" class="rfs18" @click="show = true"> 免费咨询 </van-button>
    <van-dialog
      v-model="show"
      class="dialog-contact-form rfs12"
      lazy-render
      width="3.3rem"
      getContainer="body"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :close-on-click-overlay="false"
      @cancel="show = false"
    >
      <div class="rel">
        <van-icon name="cross" class="fs16" @click="show = false" />
        <div class="tc m-v-3 color-primary rfs15" slot="title">通过连尚广告获取更多客户</div>
        <ValidationObserver v-slot="{}" ref="form" class="form db">
          <div class="form-item">
            <ValidationProvider :rules="rules.name">
              <div slot-scope="{ errors }">
                <van-field v-model="formData.name" placeholder="姓名"></van-field>
                <div class="error-tip tl" v-show="showErrorTip(formData.name, errors[0])">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form-item">
            <ValidationProvider :rules="rules.phone">
              <div slot-scope="{ errors }">
                <van-field v-model="formData.phone" maxlength="11" placeholder="手机号码"></van-field>
                <div class="error-tip tl" v-show="showErrorTip(formData.phone, errors[0])">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
          <div class="form-item">
            <ValidationProvider :rules="rules.companyName">
              <div slot-scope="{ errors }">
                <van-field v-model="formData.companyName" placeholder="公司名称"></van-field>
                <div class="error-tip tl" v-show="showErrorTip(formData.companyName, errors[0])">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
          <!-- 地区选择器 -->
          <div class="form-item" @click="doShowCitySelector">
            <ValidationProvider :rules="rules.district">
              <div slot-scope="{ errors }">
                <van-field :value="formData.district.join('-')" class="single-line tl" placeholder="地址" disabled />
                <div class="error-tip tl" v-show="showErrorTip(formData.district, errors[0])">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
          <div class="tc m-t-3">您的专属顾问会在1个工作日内联系您，为您提供服务</div>
          <div class="tc m-b-5"><span class="m-r-2">周一至周五09:00-22:00</span><span>周六至周日09:00-18:00</span></div>
          <div class="m-b-6">
            <van-button class="db full-width" size="large" type="primary" :disabled="submitting" @click="beforeSubmit"
              >立即提交</van-button
            >
          </div>
        </ValidationObserver>
        <CitySelector :show="showCitySelector" @hide="doHideCitySelector" @confirm="onCitySelected"></CitySelector>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import contactFormMixin from '@/mixins/contactForm';
import CitySelector from './CitySelector';

export default {
  name: '',
  props: {
    type: { type: String, default: 'primary' },
  },
  components: { CitySelector },
  mixins: [contactFormMixin],
  data() {
    return {
      show: false,
      showCitySelector: false,
      rules: {
        name: { required: true },
        companyName: { required: true },
        district: { required: true },
        phone: { required: true, mobile: true },
      },
      formData: { name: '', phone: '', companyName: '', district: [] },
    };
  },
  computed: {},
  watch: {},
  methods: {
    doShowCitySelector() {
      this.showCitySelector = true;
    },
    doHideCitySelector() {
      this.showCitySelector = false;
    },
    onCitySelected(val) {
      this.showCitySelector = false;
      this.formData.district = val;
    },
    showErrorTip(val, err) {
      return err;
    },
    beforeSubmit() {
      const form = this.$refs.form;
      form.validate().then(valid => {
        if (!valid) return;
        this.doSubmit()
          .then(() => {
            this.$notify({ message: '提交成功', type: 'success' });
            this.show = false;
          })
          .catch(() => {
            this.$notify({ message: '提交失败，请重试', type: 'danger' });
          });
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.contact {
}
.form {
  margin: 0 0.2rem;
}
.van-cell {
  padding-left: 0;
  &::after {
    left: 0 !important;
  }
}

.error-tip {
  color: red;
  padding: 3px 0 0;
  font-size: 12px;
  line-height: 16px;
}
.van-icon-cross {
  position: absolute;
  right: 10px;
  top: -3px;
}
</style>
<style lang="scss">
.dialog-contact-form {
  .van-field__control,
  .van-field__control:disabled {
    color: #565656;
  }
}
</style>